<template>
	<nav id="navbar">
		<slot name="navlist">
			<!-- take a prop and iterate over the nav-item list -->
			<router-link
				v-for="(item,index) in navlist"
				v-bind:key="index"
				class="nav-item"
				:to="item.linkTo"
			>
				{{item.label}}
			</router-link>
		</slot>
	</nav>
</template>

<script>
export default {
	name: 'navbar',
	props: {
		navlist: {
		/*
			an array of objects like this:
			{
				linkTo: '/home', // a string path beginning with '/'
				label: 'Home'
			},
			{ 
				linkTo: '/services/support',
				label: 'Support'
			}
		*/
		type: Array,
		required: true
		}
	}
}
</script>

<style lang="scss" scoped>
#navbar {
	grid-area: navbar;
	position: relative;
}

.nav-item {
	display: block;
	padding: 1em $qvo-spacing-default;
	color: #fff;
	font-size: 1.25em;
	text-align: left;
	text-decoration: none;

	&:hover,
	&:active,
	&.router-link-active {
		background: $qvo-color-brand-blue-lite;
	}
}
</style>